// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rx-form {
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-height: 0;
  height: 100%;
}

.rx-form__context {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding-bottom: 12px;
  border-bottom: 1px solid #E2E8F0;
  flex-shrink: 0;
}

.rx-form__context-main {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}

.rx-form__avatar {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: #E0F2FE;
  color: #0284C7;
  font-size: 12px;
  font-weight: 700;
  flex-shrink: 0;
}

.rx-form__context-name {
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  color: #0F172A;
  line-height: 1.3;
}

.rx-form__context-code {
  font-weight: 400;
  color: #64748B;
  font-size: 12px;
}

.rx-form__context-meta {
  margin: 2px 0 0;
  font-size: 12px;
  color: #64748B;
  line-height: 1.3;
}

.rx-form__context-badge {
  display: inline-flex;
  align-items: center;
  height: 22px;
  padding: 0 10px;
  border-radius: 9999px;
  background: #E0F2FE;
  color: #0284C7;
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
  flex-shrink: 0;
}

.rx-form__items {
  display: flex;
  flex-direction: column;
  gap: 12px;
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
}

.rx-form__item {
  position: relative;
  padding: 14px;
  border-radius: 12px;
  border: 1px solid #E2E8F0;
  background: #F8FAFC;
  display: flex;
  flex-direction: column;
  gap: 10px;
  flex-shrink: 0;
}

.rx-form__item-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.rx-form__item-label {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #64748B;
}

.rx-form__item-dot {
  width: 8px;
  height: 8px;
  border-radius: 9999px;
  background: #0EA5E9;
  flex-shrink: 0;
}

.rx-form__item-remove {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: #94A3B8;
  cursor: pointer;
}

.rx-form__item-remove:hover {
  background: #F1F5F9;
  color: #DC2626;
}

.rx-form__field {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.rx-form__field-label {
  font-size: 13px;
  font-weight: 600;
  color: #0F172A;
  line-height: 1.25;
}

.rx-form__required {
  color: #DC2626;
  margin-inline-start: 2px;
}

.rx-form__input,
.rx-form__textarea {
  width: 100%;
  box-sizing: border-box;
  border: 1px solid #CBD5E1;
  border-radius: 8px;
  background: #ffffff;
  color: #0F172A;
  font-family: inherit;
  font-size: 13px;
  line-height: 1.4;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
  transition: border-color 0.12s ease, box-shadow 0.12s ease;
}

.rx-form__input {
  height: 36px;
  padding: 0 12px;
}

.rx-form__textarea {
  min-height: 64px;
  padding: 10px 12px;
  resize: vertical;
}

.rx-form__input:focus,
.rx-form__textarea:focus {
  outline: none;
  border-color: #0EA5E9;
  box-shadow: 0 0 0 3px rgba(14, 165, 233, 0.2);
}

.rx-form__input::placeholder,
.rx-form__textarea::placeholder {
  color: #94A3B8;
}

.rx-form__add {
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  width: 100%;
  height: 40px;
  min-height: 40px;
  padding: 0 12px;
  border: 1px dashed #CBD5E1;
  border-radius: 8px;
  background: #ffffff;
  color: #0284C7;
  font-size: 13px;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  flex-shrink: 0;
  transition: background 0.12s ease, border-color 0.12s ease;
}

.rx-form__add:hover {
  background: #F8FAFC;
  border-color: #7DD3FC;
}

.rx-form__footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: auto;
  padding-top: 8px;
  flex-shrink: 0;
}

.rx-form__footer-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.rx-form__btn {
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 36px;
  padding: 0 16px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  border: 1px solid transparent;
  white-space: nowrap;
}

.rx-form__btn--ghost {
  border-color: transparent;
  background: #F1F5F9;
  color: #64748B;
}

.rx-form__btn--ghost:hover {
  background: #E2E8F0;
  color: #0F172A;
}

.rx-form__btn--primary {
  border-color: #0EA5E9;
  background: #0EA5E9;
  color: #ffffff;
  box-shadow: 0 1px 2px rgba(14, 165, 233, 0.25);
}

.rx-form__btn--primary:hover {
  background: #0284C7;
  border-color: #0284C7;
}

.rx-form__error {
  margin: 0;
  font-size: 12px;
  color: #DC2626;
}
`, "",{"version":3,"sources":["webpack://./src/components/forms/Prescription/style.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,oBAAoB;EACpB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,cAAc;EACd,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,wBAAwB;AAC1B;;AAEA;;EAEE,WAAW;EACX,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,4CAA4C;EAC5C,0DAA0D;AAC5D;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,cAAc;EACd,0DAA0D;AAC5D;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;AAChB","sourcesContent":[".rx-form {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  min-height: 0;\n  height: 100%;\n}\n\n.rx-form__context {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding-bottom: 12px;\n  border-bottom: 1px solid #E2E8F0;\n  flex-shrink: 0;\n}\n\n.rx-form__context-main {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-width: 0;\n}\n\n.rx-form__avatar {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border-radius: 8px;\n  background: #E0F2FE;\n  color: #0284C7;\n  font-size: 12px;\n  font-weight: 700;\n  flex-shrink: 0;\n}\n\n.rx-form__context-name {\n  margin: 0;\n  font-size: 15px;\n  font-weight: 600;\n  color: #0F172A;\n  line-height: 1.3;\n}\n\n.rx-form__context-code {\n  font-weight: 400;\n  color: #64748B;\n  font-size: 12px;\n}\n\n.rx-form__context-meta {\n  margin: 2px 0 0;\n  font-size: 12px;\n  color: #64748B;\n  line-height: 1.3;\n}\n\n.rx-form__context-badge {\n  display: inline-flex;\n  align-items: center;\n  height: 22px;\n  padding: 0 10px;\n  border-radius: 9999px;\n  background: #E0F2FE;\n  color: #0284C7;\n  font-size: 11px;\n  font-weight: 600;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n.rx-form__items {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow-y: auto;\n}\n\n.rx-form__item {\n  position: relative;\n  padding: 14px;\n  border-radius: 12px;\n  border: 1px solid #E2E8F0;\n  background: #F8FAFC;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  flex-shrink: 0;\n}\n\n.rx-form__item-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n}\n\n.rx-form__item-label {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: #64748B;\n}\n\n.rx-form__item-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 9999px;\n  background: #0EA5E9;\n  flex-shrink: 0;\n}\n\n.rx-form__item-remove {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  border: 0;\n  border-radius: 8px;\n  background: transparent;\n  color: #94A3B8;\n  cursor: pointer;\n}\n\n.rx-form__item-remove:hover {\n  background: #F1F5F9;\n  color: #DC2626;\n}\n\n.rx-form__field {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.rx-form__field-label {\n  font-size: 13px;\n  font-weight: 600;\n  color: #0F172A;\n  line-height: 1.25;\n}\n\n.rx-form__required {\n  color: #DC2626;\n  margin-inline-start: 2px;\n}\n\n.rx-form__input,\n.rx-form__textarea {\n  width: 100%;\n  box-sizing: border-box;\n  border: 1px solid #CBD5E1;\n  border-radius: 8px;\n  background: #ffffff;\n  color: #0F172A;\n  font-family: inherit;\n  font-size: 13px;\n  line-height: 1.4;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);\n  transition: border-color 0.12s ease, box-shadow 0.12s ease;\n}\n\n.rx-form__input {\n  height: 36px;\n  padding: 0 12px;\n}\n\n.rx-form__textarea {\n  min-height: 64px;\n  padding: 10px 12px;\n  resize: vertical;\n}\n\n.rx-form__input:focus,\n.rx-form__textarea:focus {\n  outline: none;\n  border-color: #0EA5E9;\n  box-shadow: 0 0 0 3px rgba(14, 165, 233, 0.2);\n}\n\n.rx-form__input::placeholder,\n.rx-form__textarea::placeholder {\n  color: #94A3B8;\n}\n\n.rx-form__add {\n  box-sizing: border-box;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  width: 100%;\n  height: 40px;\n  min-height: 40px;\n  padding: 0 12px;\n  border: 1px dashed #CBD5E1;\n  border-radius: 8px;\n  background: #ffffff;\n  color: #0284C7;\n  font-size: 13px;\n  font-weight: 600;\n  font-family: inherit;\n  cursor: pointer;\n  flex-shrink: 0;\n  transition: background 0.12s ease, border-color 0.12s ease;\n}\n\n.rx-form__add:hover {\n  background: #F8FAFC;\n  border-color: #7DD3FC;\n}\n\n.rx-form__footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-top: auto;\n  padding-top: 8px;\n  flex-shrink: 0;\n}\n\n.rx-form__footer-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.rx-form__btn {\n  box-sizing: border-box;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  height: 36px;\n  padding: 0 16px;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 600;\n  font-family: inherit;\n  cursor: pointer;\n  border: 1px solid transparent;\n  white-space: nowrap;\n}\n\n.rx-form__btn--ghost {\n  border-color: transparent;\n  background: #F1F5F9;\n  color: #64748B;\n}\n\n.rx-form__btn--ghost:hover {\n  background: #E2E8F0;\n  color: #0F172A;\n}\n\n.rx-form__btn--primary {\n  border-color: #0EA5E9;\n  background: #0EA5E9;\n  color: #ffffff;\n  box-shadow: 0 1px 2px rgba(14, 165, 233, 0.25);\n}\n\n.rx-form__btn--primary:hover {\n  background: #0284C7;\n  border-color: #0284C7;\n}\n\n.rx-form__error {\n  margin: 0;\n  font-size: 12px;\n  color: #DC2626;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
